module.exports = __webpack_public_path__ + "img/插图.128114f5.png";